const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Media URLs embed the media row's UUID as a path segment
 * (`{source}/{prefix}/{media.id}/{filename}`), which lets us recover
 * provenance for places that only persisted a URL (e.g. canvas documents).
 */
export function extractMediaIdFromUrl(url: string): string | null {
	let pathname: string
	try {
		pathname = new URL(url, window.location.origin).pathname
	} catch {
		return null
	}

	const segments = pathname.split('/')
	// The UUID segment is followed by the file name, so skip the last segment.
	for (let index = segments.length - 2; index >= 0; index--) {
		if (UUID_PATTERN.test(segments[index])) {
			return segments[index].toLowerCase()
		}
	}

	return null
}
